import { Component } from '@angular/core';
import {CardModule} from "primeng/card";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-footer-gov-co',
  standalone: true,
  imports: [
    CardModule,
    NgOptimizedImage,

  ],
  templateUrl: './footer-gov-co.component.html',
  styleUrl: './footer-gov-co.component.scss'
})
export class FooterGovCoComponent {

}
